// Function index:
//   CELL_W / CELL_H        — pixel pitch between adjacent room centres.
//   ROOM_W / ROOM_H        — pixel size of one room card.
//   PAD                    — outer scene padding.
//   roomCenter(room)       — pixel coords of a room's centre.
//   escapeHtml(s)          — replace &<>"' for safe innerHTML/title.
//
// Layout constants are shared between the SVG door layer, the room
// cards, and the scroll-into-view step in refresh().

import type { BootstrapRoom } from '../api/types.js';

export const CELL_W = 144;
export const CELL_H = 126;
export const ROOM_W = 116;
export const ROOM_H = 100;
export const PAD = 24;

export function roomCenter(room: { x: number; y: number }): { x: number; y: number } {
  return {
    x: PAD + room.x * CELL_W + ROOM_W / 2,
    y: PAD + room.y * CELL_H + ROOM_H / 2,
  };
}

export function sceneExtents(rooms: BootstrapRoom[]): { w: number; h: number } {
  let maxX = 0;
  let maxY = 0;
  for (const r of rooms) {
    if (r.x > maxX) maxX = r.x;
    if (r.y > maxY) maxY = r.y;
  }
  return {
    w: (maxX + 1) * CELL_W + PAD * 2,
    h: (maxY + 1) * CELL_H + PAD * 2,
  };
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => (
    c === '&' ? '&amp;' :
    c === '<' ? '&lt;' :
    c === '>' ? '&gt;' :
    c === '"' ? '&quot;' : '&#39;'
  ));
}
